export function titleCase(str: string) {
  return str.replace(/^./, str[0]?.toUpperCase());
}
